import { render, staticRenderFns } from "./ResearchApplications.vue?vue&type=template&id=5a97d549"
import script from "./ResearchApplications.vue?vue&type=script&lang=js"
export * from "./ResearchApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports